import { combineReducers } from 'redux';
import create from './create';

export default combineReducers({
  create,
});
